import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'degree',
})
export class DegreePipe implements PipeTransform {
	transform(value: number | undefined | null): any {
		if (value != undefined) {
			return `${value} °`;
		} else {
			return '-.--';
		}
	}
}
